export default __webpack_public_path__ + "static/media/close_icon.07ce9eef.svg";